import { patchQuestInputSchema, patchQuestOutputSchema } from '@zealy/utils';
export const updateQuestInputSchema = patchQuestInputSchema;
export const updateQuestOutputSchema = patchQuestOutputSchema;
